import React from "react"
import classNames from "classnames"

import { getCharPortrait } from "@/utils/assets"

import styles from "./index.module.less"

interface OperatorV2Props {
    data: {
        id: string
        name: string
        profession: string
        rarity: number
    }
    className?: string
    style?: React.CSSProperties
}

const OperatorV2: React.FC<OperatorV2Props> = (props) => {
    const { data, className, style } = props

    return (
        <div className={classNames(styles.operator, className)} style={style}>
            <div className={styles.line} />
            <div className={styles.bg} />
            <img
                className={styles.portrait}
                src={getCharPortrait(data.id)}
                loading="lazy"
            />
            <div className={styles.shadow} />
            <div className={styles.bottom} />
            <div className={styles.detail}>
                <div className={styles.rarity}>
                    {new Array(data.rarity + 1).fill(0).map((_, i) => (
                        <div key={i} className={styles.star} />
                    ))}
                </div>
                <div className={styles.row}>
                    <div
                        className={styles.profession}
                        data-value={data.profession.toLowerCase()}
                    />
                    <div className={styles.name}>{data.name}</div>
                </div>
            </div>
        </div>
    )
}

export default OperatorV2
